import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { fetchRefinementApprovalPatient } from '../services/patient';

export function useRefinementApprovalPatient() {
    const { id } = useParams<{ id: string }>();

    return useQuery({
        queryKey: ['patient', id, 'refinement-approval'],
        queryFn: () => fetchRefinementApprovalPatient(id!),
        enabled: id !== undefined,
        staleTime: 0
    });
}
